import {getUuid4} from '../../../utils/getUuid4';

export const getUserUuid: () => string = () => {
    const stored_uuid = localStorage.getItem('p_uuidv4');
    if (stored_uuid) {
        return stored_uuid;
    }

    const id = getUuid4();
    localStorage.setItem('p_uuidv4', id);

    return id;
};
